import React, { useCallback } from 'react'
import { Divider, Select, Spin, Tooltip, DatePicker, Rate } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import EmptyCandidateIcon from 'components/icons/EmptyCandidateIcon'
import DriveStatus from 'modules/Drives/Components/DriveStatus/index.js'
import AssessmentStatusBadge from 'modules/Drives/Components/AssessmentStatusBadge/index.js'
import {
  EmptyWrapper,
  VectorRight,
} from 'modules/Drives/Components/Styles/style'
import IndividualDriveFilter from 'modules/Drives/ViewDriveRole/IndividualDriveTable/DriveFilter/index'
import CandidateInfo from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/index'
import { getPromotion } from 'modules/Roles/actions'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactDOMServer from 'react-dom/server'
import MoveToNextRoundTemplate from 'components/EmailTemplate/MoveToNextRoundTemplate'
import RejectionTemplate from 'components/EmailTemplate/RejectionTemplate'
import { sendNotificationBulkEmail, sendNotificationBulkEmailWhatsapp } from 'modules/Users/actions'
import styled from 'styled-components'
import DropdownCard from '../../../../../src/modules/Drives/ViewDriveRole/IndividualDriveTable/HoverCard/index'
import { StyledTableSqare } from 'components/TableStyles/TableStylesSqare/TableStylesSqare'
import VectorRed from 'components/TableStyles/TableStylesSqare/VectorRight.svg'
import {
  EmptyElement,
  EmptySpan,
} from 'components/UIComponents/CommonStyledDiv'
import ResumeDownload from 'components/icons/DriveTableIcon/ResumeDownload'
import PanelDrawer from './PanelDetailsDrawer/index'
import SelectAssessmentDrawer from './SelectAssessmentDrawer/index'
import SelectionDisplay from './SelectionDisplay'
import TableStatusIcon from './TableStatusIcon'
import { debounce } from 'utils/debounce'
import CustomModal from 'components/Modal/index.js'
import skipRoundIcon from 'components/icons/OBJECTS.svg'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import SelectTickIcon from 'components/icons/SelectTickIcon'
import ArrowForward from 'components/icons/ArrowForward'
import moment from 'moment'
import Drawer from 'components/Drawer'
import ResolveConflict from '../../Components/ResolveConflict'
import { ConflictName, ShortList, TextEllipse } from '../Style/style'
import { toCamelCase } from '../../utils'
import { monthList } from '../../../../utils/const'
import OfferTableStatusIcon from './TableStatusIcon/OfferTableStatusIcon'

const offerStatusArr = ['REJECTED', 'RELEASED', 'ACCEPTED']

// Helper function to count active filter categories
const getActiveFilterCount = (filterValues) => {
  if (!filterValues) return 0;
  
  let activeCount = 0;
  
  // Check array type filters
  const arrayFilters = [
    'selectedRound', 'selectedStatus', 'selectedDegrees', 'selectedDepartments', 
    'selectedSpecializations', 'selectedYears', 'selectedSkills', 'selectedColleges', 
    'selectedCollegeStates', 'selectedCollegeCities', 'selectedGender', 'selectScories',
    'selectedRoundScore', 'selectedQualifyingQuestions', 'selectedCustomQuestions', 'selectedPermanentState',
    'selectedPermanentCity', 'selectedCurrentState', 'selectedCurrentCity', 
    'selectedPreferredLocation', 'selectedFunction', 'selectedRole',
    'selectedDurationYear', 'selectedDurationMonth', 'selectedAppliedDateRange',
    'selectedAssessmentStatus'
  ];
  
  arrayFilters.forEach(filter => {
    if (Array.isArray(filterValues[filter]) && filterValues[filter].length > 0) {
      activeCount++;
    }
  });
  
  // Check object type filters
  if (filterValues.selectedAge && (filterValues.selectedAge.from || filterValues.selectedAge.to)) {
    activeCount++;
  }
  
  if (filterValues.selectedQuickAge && (filterValues.selectedQuickAge.from || filterValues.selectedQuickAge.to)) {
    activeCount++;
  }
  
  // Check other specific filters
  if (filterValues.selectedScoreFilterType) activeCount++;
  if (filterValues.selectedCurrentArrearFilterType) activeCount++;
  if (filterValues.selectedPastArrearFilterType) activeCount++;
  if (filterValues.selectedCurrentArrearCount !== null && filterValues.selectedCurrentArrearCount !== undefined) activeCount++;
  if (filterValues.selectedPastArrearCount !== null && filterValues.selectedPastArrearCount !== undefined) activeCount++;
  if (filterValues.includeArrears) activeCount++;
  
  return activeCount;
};

export const centerText = styled(Flex)`
  align-content: center;
`

const StyledSelect = styled(Select)`
  .ant-select-selector {
    width: 7em !important;
    height: 2.6em !important;
    justify-content: center !important;
    align-items: center !important;
    border-color: blue !important;
    border-radius: 5px !important;
    .ant-select-selection-item {
      font-weight: bold;
    }
  }
`
const StyledDivider = styled(Divider)`
  margin: 0 !important;
  border-color: rgba(223, 223, 223, 1);
`

const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  margin-top: 5px;
`

const IconText = styled.h4`
  margin-bottom: 6px;

  color: rgba(128, 134, 151, 1);
`

export const Minus = styled.div`
  display: flex;
  justify-content: center;
`
const DataTextContainar = styled.div``
const IndividualDriveTable = ({
  tabIndex,
  driveData,
  scheduleDrawer,
  setScheduleDrawer,
  candidateDeatils,
  currentPage,
  setCurrentPage,
  setSearchValue,
  setSortBy,
  isLoading,
  candidateRating,
  setCandidateRating,
  interviewRound,
  setInterviewRound,
  getCandidateList,
  rolesMetrics,
  degreeList,
  searchParams,
  setSearchParams,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  setSelectedCandidateId,
  setSelectedCandidate,
  selectedCandidate,
  collegeList,
  college,
  setCollege,
  setCollegeSearch,
  getCandidateDetails,
  candidateDetails,
  getSingleCandidateInterviewDetails,
  driveId,
  roleId,
  candidateInterviewDetails,
  updateInterviewStatus,
  selectedRoundType,
  status,
  stage,
  candidateInfoData,
  setCandidateInfoData,
  setStatus,
  filterStatus,
  setFilterStatus,
  getRoleMetrics,
  selectedCandidateId,
  setReleaseOffer,
  currentTab,
  singleRoleData,
  searchValue,
  stages,
  newDriveStatusData,
  newDriveScoreData,
  setScorePayload,
  getNewIndividualDriveStatus,
  getPanelList,
  panelValue,
  setPanelValue,
  setPanelData,
  panelData,
  getDriveRoleMetrics,
  roundName,
  setIsAllSelected,
  isAllSelected,
  selectedTab,
  setWholeSelect,
  wholeSelect,
  setSelectedFilterValue,
  selectedFilterValue,
  filterValues,
  setFilterValues,
  setBulkDownload,
  setStudentListId,
  setActionDrawer,
  getRounds,
  getStatus,
  getYear,
  getCollegeListForFilter,
  getSkillForFilter,
  getQuestionForFilter,
  getCustomQuestionFilterOptions,
  getWorkExperienceForFilter,
  getLocationForFilter,
  getDegreeForFilter,
  getNewDriveScore,
  nextRoundFunction,
  fetchBulkStudentIds,
  rounds,
  nextRoundData,
  popSelectedRound,
  setPopSelectedRound,
  getConflictCandidates,
  setISLoading,
  updateResolveConflictCandidates,
  conflictData,
  setConflictData,
}) => {
  const scoreFilterRef = useRef(null)
  const dispatch = new useDispatch()
  const userData = useSelector(state => state?.auth?.userData)
  const corporateData = useSelector(state => state?.auth?.corporateData)
  const [candidateInfo, setCandidateInfo] = useState(false)
  const [expand, setExpand] = useState(false)
  const [visibleHeadings, setVisibleHeadings] = useState({})
  const [enableSelectAll, setEnableSelectAll] = useState(false)
  const [search, setSearch] = useState('')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const roundId = searchParams.get('roundId')
  const [data, setData] = useState([])

  const [filterOptions, setFilterOptions] = useState({
    roundList: [],
    statusList: [],
    degreeList: [],
    departList: [],
    splList: [],
    yearList: [],
    collegeCityList: [],
    collegeStateList: [],
    collegeList: [],
    scoreList: [],
    skillList: [],
    functionList: [],
    roleList: [],
    durationYearList: [],
    durationMonthsList: [],
    permanentStateList: [],
    permanentCityList: [],
    currentStateList: [],
    currentCityList: [],
    preferredLocationList: [],
    durationYearList: [],
    durationMonthList: [],
    roundScoreList: [],
    questionList: [],
  })
  const [selectedQuickOption, setSelectedQuickOption] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [conflictDrawer, setConflictDrawer] = useState(false)
  const [selectAssessmentDrawerOpen, setSelectAssessmentDrawerOpen] = useState(false)
  const [conflictFilter, setConflictFilter] = useState({
    search: '',
    page: 0,
  })
  const [datePickerModal, setDatePickerModal] = useState({
    visible: false,
    status: null,
    selectedDate: null,
  })

  const [debouncedSearch, setDebouncedSearch] = useState(
    () => conflictFilter.search
  )
  // filterValues / setFilterValues are lifted to ViewDriveRole (passed as
  // props) so the panel selections persist across this component's remounts on
  // stage/round changes. Do not re-introduce local state here.

  const filterConfigs = [
    {
      key: 'selectedRound',
      api: getRounds,
      optionKey: 'roundList',
      searchParam: value => value,
      extract: result => result || [],
    },
    {
      key: 'selectedStatus',
      api: getStatus,
      optionKey: 'statusList',
      searchParam: value => value,
      extract: result => result || [],
    },
    {
      key: 'selectedYears',
      api: getYear,
      optionKey: 'yearList',
      searchParam: value => value,
      extract: result => result || [],
    },
    {
      key: 'selectedCollegeStates',
      api: getCollegeListForFilter,
      optionKey: 'collegeStateList',
      searchParam: value => ({ stateSearch: value }),
      extract: result => result?.states || [],
    },
    {
      key: 'selectedCollegeCities',
      api: getCollegeListForFilter,
      optionKey: 'collegeCityList',
      searchParam: value => ({ citySearch: value }),
      extract: result => result?.cities || [],
    },
    {
      key: 'selectedColleges',
      api: getCollegeListForFilter,
      optionKey: 'collegeList',
      searchParam: value => ({ collegeSearch: value }),
      extract: result => result?.collegeNames || [],
    },

    {
      key: 'selectedPermanentState',
      api: getLocationForFilter,
      optionKey: 'permanentStateList',
      searchParam: value => ({ psSearch: value }),
      extract: result => result.permanentLocationData.states || [],
    },
    {
      key: 'selectedPermanentCity',
      api: getLocationForFilter,
      optionKey: 'permanentCityList',
      searchParam: value => ({ pcSearch: value }),
      extract: result => result.permanentLocationData.cities || [],
    },
    {
      key: 'selectedCurrentState',
      api: getLocationForFilter,
      optionKey: 'currentStateList',
      searchParam: value => ({ csSearch: value }),
      extract: result => result.currentLocationData.states || [],
    },
    {
      key: 'selectedCurrentCity',
      api: getLocationForFilter,
      optionKey: 'currentCityList',
      searchParam: value => ({ ccSearch: value }),
      extract: result => result.currentLocationData.cities || [],
    },
    {
      key: 'selectedPreferredLocation',
      api: getLocationForFilter,
      optionKey: 'preferredLocationList',
      searchParam: value => value,
      extract: result => result.preferredLocation || [],
    },
    {
      key: 'selectedSkills',
      api: getSkillForFilter,
      optionKey: 'skillList',
      searchParam: value => value,
      extract: result => result || [],
    },
    {
      key: 'selectedDegrees',
      api: getDegreeForFilter,
      optionKey: 'degreeList',
      searchParam: value => value,
      extract: result => result || [],
      getPayload: (value, state) => {
        return { search: value }
      },
    },
    {
      key: 'selectedDepartments',
      api: getDegreeForFilter,
      optionKey: 'departList',
      searchParam: value => value,
      extract: result => result || [],
      getPayload: (value, state) => {
        return { search: value }
      },
    },
    {
      key: 'selectedSpecializations',
      api: getDegreeForFilter,
      optionKey: 'splList',
      searchParam: value => value,
      extract: result => result || [],
    },
    {
      key: 'selectedYears',
      api: getYear,
      optionKey: 'yearList',
      searchParam: value => value,
      extract: result => result || [],
    },
    {
      key: 'selectedFunction',
      api: getWorkExperienceForFilter,
      optionKey: 'functionList',
      searchParam: value => ({ functionSearch: value }),
      extract: result => result.functions || [],
    },
    {
      key: 'selectedRole',
      api: getWorkExperienceForFilter,
      optionKey: 'roleList',
      searchParam: value => ({ roleSearch: value }),
      extract: result => result.roles || [],
    },
    {
      key: 'selectedQualifyingQuestions',
      api: getQuestionForFilter,
      optionKey: 'questionList',
      searchParam: value => value,
      extract: result => result || [],
    },
  ]
  const studentDetailsAPI = async std_Id => {
    const { status } = await getCandidateDetails({
      studentId: std_Id,
      roleId,
    })

    if (status >= 200 && status < 300) {
      setCandidateInfo(true)
    }
  }

  const onPageChange = pagNum => {
    setCurrentPage(pagNum - 1)
    // Preserve current filter payload when navigating pages
    let currentFilterPayload = selectedFilterValue || {}
    // Fix: Check if selectedFilterValue is an object with properties, not array length
    const hasFilters = currentFilterPayload && Object.keys(currentFilterPayload).length > 0
    currentFilterPayload = hasFilters ? currentFilterPayload : {}
    getCandidateList(currentFilterPayload, pagNum - 1)
  }

  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }

  const getFilterConfig = key => filterConfigs.find(cfg => cfg.key === key)

  const fetchSearch = async (key, value) => {
    setSearch(value)
    const config = getFilterConfig(key)
    if (!config) return

    const searchParam = config.getPayload
      ? config.getPayload(value, filterValues)
      : config.searchParam
      ? config.searchParam(value)
      : value

    const apiCall = config.api(roleId, stage, searchParam)
    const result =
      typeof apiCall === 'function' ? await apiCall() : await apiCall

    if (key === 'selectedDegrees') {
      const domainData =
        result?.result?.map(item => ({
          title: item.name,
          value: item.id,
          domainId: item.id,
        })) || []

      const domainSelect = [
        {
          title: 'Select All',
          value: 'Select All',
          children: domainData,
        },
      ]

      setFilterOptions(prev => ({
        ...prev,
        [config.optionKey]: domainSelect,
      }))
      return
    }

    if (key === 'selectedDepartments') {
      const degreeIds = filterValues.selectedDegrees?.join(',') || ''

      const payload = {
        forStream: true,
        degreeIds,
        stage,
      }

      const departmentResult = await config.api(roleId, stage, payload)
      const departmentData = departmentResult.map(item => ({
        value: item.id,
        degreeId: item.id,
        title: item.name,
        children: item.degreeStreamMap.map(stream => ({
          value: `${item.id} ${stream.stream.id}`,
          departId: stream.stream.id,
          title: stream.stream.name,
          nameValue: `Department - ${stream.stream.name}`,
          role: 'Department',
          degreeId: item.id,
        })),
      }))

      const departSelect = [
        {
          title: 'Select All',
          value: 'Select All',
          children: departmentData,
        },
      ]

      setFilterOptions(prev => ({
        ...prev,
        [config.optionKey]: departSelect,
      }))
      return
    }

    if (key === 'selectedSpecializations') {
      const degreeIds = filterValues.selectedDegrees?.join(',') || ''
      const allStreamIds =
        filterValues.selectedDepartments?.flatMap(v => v.split(' ')) || []
      const filteredStreamIds = allStreamIds.filter(
        id => !filterValues.selectedDegrees.includes(id)
      )
      const payload = {
        forSpecialisation: true,
        degreeIds,
        streamIds: filteredStreamIds.join(','),
        stage,
      }

      const specializationResult = await config.api(roleId, stage, payload)
      const splData = specializationResult.map(item => ({
        value: item.id,
        degreeId: item.id,
        title: item.name,
        nameValue: `Degree - ${item.name}`,
        role: 'Degree',
        children: item.degreeStreamMap.map(stream => ({
          value: `${item.id} ${stream.stream.id}`,
          departId: stream.stream.id,
          title: stream.stream.name,
          nameValue: `Department - ${stream.stream.name}`,
          role: 'Department',
          degreeId: item.id,
          children: stream.specialisationMasterStreamMap.map(
            specialisation => ({
              value: `${stream.stream.id} ${specialisation.specialisationMaster.id}`,
              specialisationId: specialisation.specialisationMaster.id,
              title: specialisation.specialisationMaster.name,
              nameValue: `Specialisation - ${specialisation.specialisationMaster.name}`,
              role: 'Specialisation',
              degreeId: item.id,
              departId: stream.stream.id,
            })
          ),
        })),
      }))

      const splSelect = [
        {
          title: 'Select All',
          value: 'Select All',
          children: splData,
        },
      ]

      setFilterOptions(prev => ({
        ...prev,
        [config.optionKey]: splSelect,
      }))
      return
    }

    // Default case for other keys
    setFilterOptions(prev => ({
      ...prev,
      [config.optionKey]: config.extract(result),
    }))
  }

  const containerRef = useRef(null)
  const fetchOptions = async () => {
    try {
      const rounds = await getRounds(roleId, stage)
      const status = await getStatus(roleId, stage)
      // Transform statuses for offer context
      const transformedStatus = status.map(item => {
        let nextName = item.name
        if (nextName === 'SELECTED') nextName = 'Intent To Offer'
        if (String(stage).toLowerCase() === 'offer' && nextName === 'REJECTED') {
          nextName = 'Offer Declined'
        }
        if (nextName === 'TO_BE_UPDATED') nextName = 'To be updated'
        return nextName === item.name ? item : { ...item, name: nextName }
      })
      const year = await getYear(roleId, stage)
      const collegeList = await getCollegeListForFilter(roleId, stage)
      const skillList = await getSkillForFilter(roleId, stage)
      const questionList = await getQuestionForFilter(roleId, stage)
      const customQuestionList = await getCustomQuestionFilterOptions(roleId)
      const workExperienceList = await getWorkExperienceForFilter(roleId, stage)
      const getLocationList = await getLocationForFilter(roleId, stage)
      const degreeList = await getDegreeForFilter(roleId, stage)
      const scoreList = await getNewDriveScore(driveId, roleId, stage)

      const domainData =
        degreeList?.length !== 0 &&
        degreeList?.result?.map((item, index) => {
          return {
            title: item.name,
            value: item.id,
            domainId: item.id,
          }
        })

      const domainSelect = [
        {
          title: 'Select All',
          value: 'Select All',
          children: domainData,
        },
      ]
      setFilterOptions(prev => ({
        ...prev,
        roundList: rounds,
        statusList: transformedStatus,
        yearList: year,
        collegeList: collegeList?.collegeNames,
        collegeCityList: collegeList?.cities,
        collegeStateList: collegeList?.states,
        skillList: skillList,
        roleList: workExperienceList.roles,
        functionList: workExperienceList.functions,
        durationYearList: workExperienceList?.years,
        durationMonthList: monthList,
        permanentCityList: getLocationList?.permanentLocationData.cities,
        permanentStateList: getLocationList?.permanentLocationData.states,
        currentCityList: getLocationList?.currentLocationData.cities,
        currentStateList: getLocationList?.currentLocationData.states,
        preferredLocationList: getLocationList?.preferredLocation,
        degreeList: domainSelect,
        questionList: questionList,
        customQuestionList: customQuestionList,
        roundScoreList: scoreList?.data?.data,
      }))
    } catch (error) {
      console.error('❌ Error in fetchOptions:', error)
    }
  }

  useEffect(() => {
    if ((roleId && stage) || stage === null) {
      // Refresh the dropdown OPTIONS for the new stage/role, but do NOT reset
      // the panel SELECTIONS — filterValues is lifted to the parent and must
      // persist across stage/round changes so the applied filter stays shown
      // in the panel (and the list stays filtered) when navigating back.
      fetchOptions()
    }
  }, [roleId, stage])
  // Dedicated effect for the Round Score filter: fetchOptions runs ~11
  // sequential awaits before populating roundScoreList — if any earlier
  // call fails, score/list never gets reached and the panel stays empty.
  // Fetch it independently so the Round Score panel always has data when
  // /score/list returns 200.
  useEffect(() => {
    let cancelled = false
    if (!roleId) return
    if (stage === 'all_candidates' || stage === 'offer') return
    ;(async () => {
      try {
        const response = await getNewDriveScore(driveId, roleId, stage)
        const list = response?.data?.data
        if (cancelled || !Array.isArray(list)) return
        setFilterOptions(prev => ({ ...prev, roundScoreList: list }))
      } catch (err) {
        console.error('[round-score] independent fetch failed:', err)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [driveId, roleId, stage])
  // Dedicated effect for the Degree and Year of Passing filters. The bulk
  // fetchOptions runs ~11 sequential awaits and transforms (e.g. status.map)
  // before the degree/year calls — if an earlier call/transform throws (which
  // happens on some stages/rounds), those two API calls are never reached and
  // the dropdowns stay empty. Fetch them independently so they always load (and
  // re-fetch on stage/round change). Mirrors the round-score effect above.
  useEffect(() => {
    let cancelled = false
    if (!roleId) return
    ;(async () => {
      try {
        const degreeResult = await getDegreeForFilter(roleId, stage, {
          search: '',
        })
        if (!cancelled && Array.isArray(degreeResult?.result)) {
          const domainData = degreeResult.result.map(item => ({
            title: item.name,
            value: item.id,
            domainId: item.id,
          }))
          setFilterOptions(prev => ({
            ...prev,
            degreeList: [
              { title: 'Select All', value: 'Select All', children: domainData },
            ],
          }))
        }
      } catch (err) {
        console.error('[degree-filter] independent fetch failed:', err)
      }
      try {
        const yearResult = await getYear(roleId, stage)
        if (!cancelled && Array.isArray(yearResult)) {
          setFilterOptions(prev => ({ ...prev, yearList: yearResult }))
        }
      } catch (err) {
        console.error('[year-filter] independent fetch failed:', err)
      }
      // "Duration in months" is a static 1–12 list (no API). fetchOptions sets
      // it, but that can abort before it runs, so set it here too.
      if (!cancelled) {
        setFilterOptions(prev => ({ ...prev, durationMonthList: monthList }))
      }
      // Status filter (with the offer-context name transform fetchOptions applies).
      try {
        const statusResult = await getStatus(roleId, stage)
        if (!cancelled && Array.isArray(statusResult)) {
          const transformedStatus = statusResult.map(item => {
            let nextName = item.name
            if (nextName === 'SELECTED') nextName = 'Intent To Offer'
            if (String(stage).toLowerCase() === 'offer' && nextName === 'REJECTED') {
              nextName = 'Offer Declined'
            }
            if (nextName === 'TO_BE_UPDATED') nextName = 'To be updated'
            return nextName === item.name ? item : { ...item, name: nextName }
          })
          setFilterOptions(prev => ({ ...prev, statusList: transformedStatus }))
        }
      } catch (err) {
        console.error('[status-filter] independent fetch failed:', err)
      }
      // Skills filter.
      try {
        const skillResult = await getSkillForFilter(roleId, stage)
        if (!cancelled && Array.isArray(skillResult)) {
          setFilterOptions(prev => ({ ...prev, skillList: skillResult }))
        }
      } catch (err) {
        console.error('[skill-filter] independent fetch failed:', err)
      }
      // College Name & Location filter.
      try {
        const collegeResult = await getCollegeListForFilter(roleId, stage)
        if (!cancelled && collegeResult && typeof collegeResult === 'object') {
          setFilterOptions(prev => ({
            ...prev,
            collegeList: collegeResult?.collegeNames ?? [],
            collegeCityList: collegeResult?.cities ?? [],
            collegeStateList: collegeResult?.states ?? [],
          }))
        }
      } catch (err) {
        console.error('[college-filter] independent fetch failed:', err)
      }
      // Work Experience filter (Function / Role / Duration).
      try {
        const workExperienceResult = await getWorkExperienceForFilter(roleId, stage)
        if (
          !cancelled &&
          workExperienceResult &&
          typeof workExperienceResult === 'object'
        ) {
          setFilterOptions(prev => ({
            ...prev,
            roleList: workExperienceResult?.roles ?? [],
            functionList: workExperienceResult?.functions ?? [],
            durationYearList: workExperienceResult?.years ?? [],
          }))
        }
      } catch (err) {
        console.error('[work-experience-filter] independent fetch failed:', err)
      }
      // Location filter (Permanent / Current / Preferred).
      try {
        const locationResult = await getLocationForFilter(roleId, stage)
        if (!cancelled && locationResult && typeof locationResult === 'object') {
          setFilterOptions(prev => ({
            ...prev,
            permanentCityList:
              locationResult?.permanentLocationData?.cities ?? [],
            permanentStateList:
              locationResult?.permanentLocationData?.states ?? [],
            currentCityList: locationResult?.currentLocationData?.cities ?? [],
            currentStateList: locationResult?.currentLocationData?.states ?? [],
            preferredLocationList: locationResult?.preferredLocation ?? [],
          }))
        }
      } catch (err) {
        console.error('[location-filter] independent fetch failed:', err)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [roleId, stage])
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setVisibleHeadings({})
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const toggleHeading = index => {
    setVisibleHeadings(prevVisibleHeadings => ({
      ...prevVisibleHeadings,
      [index]: !prevVisibleHeadings[index],
    }))
  }

  const handleNameClick = candidateData => {
    setCandidateInfo(true)

    setSelectedCandidate([candidateData?.student])
    studentDetailsAPI(candidateData?.student?.id)
    getSingleCandidateInterviewDetails(
      roleId,
      driveId,
      candidateData?.student?.id
    )
    setCandidateInfoData(candidateData)
    // dispatch(getPromotion(candidateData?.student?.id))
  }
  const collapseExtend = candidateDeatils?.topics?.find(
    item => item?.subTopic?.length > 0
  )
  const columns = [
    {
      width: 120,
      title: <div style={{ width: '90%' }}>Status</div>,
      dataIndex: 'status',
      key: stage == 'offer' ? 'offerStatus' : 'status',
      sorter: true,
      fixed: 'left',
      sortDirections: ['ascend', 'descend'],
      render: (status, record, index) => {
        let statusValue
        if (stages === 'offer') {
          if (record.offerStatus === 'SHORTLISTED') {
            statusValue = 'INTENT'
          } 
          else if(record.offerStatus === 'REJECTED') {
            statusValue = 'REJECT'
          }
          else {
            statusValue = record.offerStatus
          }
        } else if (stages === 'all_candidates') {
          if (record.offerStatus === 'REJECTED') {
            statusValue = 'REJECT'
          } else if (record.offerStatus === 'ACCEPTED') {
            statusValue = 'ACCEPTED'
          }  else if (record.offerStatus === 'JOINED') {
            statusValue = 'JOINED'
          } else if(record.offerStatus === 'LEFTED'){
            statusValue = 'LEFTED'
          }else if (record.offerStatus === 'RELEASED') {
            statusValue = 'RELEASED'
          } 
          else if(record.offerStatus === 'SHORTLISTED' && record.status === 'REJECT') {
            statusValue = 'REJECTED'
          }
          else if (record.offerStatus === 'SHORTLISTED' && record.status === 'SELECTED') {
            statusValue = 'INTENT'
          } 
          else {
            statusValue = record.status
          }

        } else if(record.offerStatus === 'SHORTLISTED' && record.status === 'REJECT') {
          statusValue = 'REJECTED'
        } else {
          statusValue = record.status
          // Fix for incorrect "SKIPPED" status display
          // Map SKIPPED status to appropriate status based on context
          // if (record.status === 'SKIPPED') {
          //   // Check if student has actually participated in any round
          //   if (record.student_interview_interviewer_map && record.student_interview_interviewer_map.length > 0) {
          //     // If student has interview records, show their actual status
          //   //  statusValue = record.student_interview_interviewer_map[0]?.status || 'TO_BE_UPDATED'
          //   } else {
          //     // If no interview records, student is likely just applied
          //     statusValue = 'APPLIED'
          //   }
          // }
          //  else {
          //   statusValue = record.status
          // }

        }
        
        return (
          <div ref={containerRef}>
            <EmptyElement onClick={() => toggleHeading(index)}>
              {status == 'STATUS_CONFLICT' && (
                <VectorRight>
                  <img src={VectorRed} alt="vectorImage" />
                  {visibleHeadings[index] && (
                    <DropdownCard
                      data={record?.student_interview_interviewer_map}
                    />
                  )}
                </VectorRight>
              )}

              <DriveStatus
                status={statusValue}
                offerStatus={record?.offerStatus}
              />
            </EmptyElement>
          </div>
        )
      },
    },

    {
      width: 150,
      title: 'Name',
      dataIndex: 'firstName',
      fixed: 'left',
      key: 'firstName',
      sortDirections: ['ascend', 'descend'],
      render: (_, candidateData) => {
        let name =
          candidateData?.student?.firstName +
          ' ' +
          candidateData?.student?.lastName

        return (
          <FlexWrap alignCenter gap="8px">
            <RowNumberData style={{ gap: '5px' }}>
              <AntdAvatar
                style={{
                  verticalAlign: 'middle',
                }}
                src={candidateData?.student?.profileUrl}
                IconName={candidateData?.student?.firstName?.split('')[0]}
                size={35}
              ></AntdAvatar>
              <div>
                <Tooltip title={name}>
                  <EmptySpan
                    style={{
                      color: 'rgba(50, 73, 215, 1)',
                      fontWeight: 'bold',
                      cursor: 'pointer', // Add cursor pointer
                    }}
                    onClick={() => handleNameClick(candidateData)}
                  >
                    {candidateData?.student?.firstName
                      ? `${
                          (name?.length > 16
                            ? name?.substring(0, 16) + '..'
                            : name) || '-'
                        }`
                      : 0}
                  </EmptySpan>
                </Tooltip>
                <p style={{ color: '#bfbfbf' }}>
                  {candidateData?.student?.prefixId ?? '-'}
                </p>
              </div>
            </RowNumberData>
          </FlexWrap>
        )
      },
    },
    {
      width: 180,
      title: 'Contact details ',
      dataIndex: 'instituteCampusName',
      key: 'instituteCampusName',
      sortDirections: ['ascend', 'descend'],
      render: (_, { student }) => (
        <RowNumberData>
          <DataTextContainar
            style={{
              width: '90%',
            }}
          >
            <div>{student?.studentPersonalProfile?.phoneNumber ?? '-'}</div>
            <Tooltip title={student?.studentPersonalProfile?.primaryEmail}>
              <div
                style={{
                  textWrap: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textTransform: 'lowercase',
                }}
              >
                {student?.studentPersonalProfile?.primaryEmail}
              </div>
            </Tooltip>
          </DataTextContainar>
        </RowNumberData>
      ),
    },
    {
      title: 'Applied Date & Time',
      dataIndex: 'appliedDate',
      sorter: true,
      key: 'appliedDate',
      align: 'center',
      width: 100,
      hidden: !singleRoleData?.isRankingActive,
      sortDirections: ['ascend', 'descend'],
      render: (_, rowData) => (
        <RowNumberData style={{ display: 'flex', justifyContent: 'center' }}>
          {rowData?.appliedDate
            ? moment(rowData.appliedDate).format('DD/MM/YYYY hh:mm A')
            : '-'}
        </RowNumberData>
      ),
    },
    {
  title: 'Matched By',
  key: 'matchedBy',
  sorter: true,
  align: 'center',
  hidden: stage == 'all_candidates',
  sortDirections: ['ascend', 'descend'],
  width: 100,
  render: (_, rowData) => {
    const score = rowData?.aiMatchScore?.overall_score || 0;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Rate
          disabled
          allowHalf
          value={score}
          style={{ fontSize: 12, color: '#EF9F14' }} // gold color like Figma
        />
        <span style={{ fontSize: 12, color: '#555' }}>
          {score}
        </span>
      </div>
    );
  },
},
    {
      title: 'Current Round',
      dataIndex: 'stage',
      sorter: true,
      key: 'stage',
      width: 100,
      hidden: stage !== 'all_candidates',
      sortDirections: ['ascend', 'descend'],
      render: stage => (
        <RowNumberData>
          {!stage
            ? '-'
            : stage === 'offer'
            ? 'Intent to Offer'
            : stage.length > 18
            ? `${stage.substr(0, 18)}...`
            : stage}
        </RowNumberData>
      ),
    },
    {
      // Shown only when the round being viewed has an assessment mapped to it
      // (backend sets assessmentStatusColumn). Reads the per-candidate label
      // computed server-side: Invite Pending / Pending / Dropped Off / Completed.
      title: 'Assessment Status',
      dataIndex: 'assessment_status',
      key: 'assessment_status',
      width: 140,
      align: 'center',
      hidden: !candidateDeatils?.assessmentStatusColumn || stage === 'offer',
      render: assessment_status => (
        <AssessmentStatusBadge status={assessment_status} />
      ),
    },

    ...(candidateDeatils?.topics || []).reduce((acc, { topic, subTopic }) => {
      if (!topic) return acc
      const originalTopic = topic
      const mainTopic = topic + 'avg'
      // Headline sub-topics float to the front so the round's summary columns
      // (Total Score, CEFR Level for Communication) render immediately after
      // the Assessment Status column, ahead of the per-ability breakdown.
      const HEADLINE_SUBTOPICS = ['totalScore', 'cefrLevel']
      const orderedSubTopic = [
        ...HEADLINE_SUBTOPICS.filter(k => (subTopic || []).includes(k)),
        ...(subTopic || []).filter(k => !HEADLINE_SUBTOPICS.includes(k)),
      ]
      const topicAndSubtopics = [mainTopic, ...orderedSubTopic]
      const formatSubTopicLabel = key => {
        if (!key || typeof key !== 'string') return key
        if (key === 'cefrLevel') return 'CEFR Level'
        if (key === 'englishVerbalScore') return 'Verbal Score'
        if (key === 'overallScore') return 'Overall Score'
        // Only split camelCase; leave user-defined names (e.g. custom-
        // assessment section titles like "Logical Ability") untouched.
        if (!/\s/.test(key) && /[A-Z]/.test(key)) {
          return key.replace(/([A-Z])/g, ' $1')
        }
        return key
      }
      // When the assessment dispatcher already produces an explicit "overall"
      // sub-topic column (overallPercentage / overallScore for Aptitude/Role-
      // Based, totalScore for Communication), the round-avg column duplicates
      // it and causes confusion — suppress the avg in that case. Sheet-only
      // flows have no overall* sub-topic, so the avg column continues to
      // render unchanged for them.
      const hasOverallSubTopic = (subTopic || []).some(s =>
        s === 'overallPercentage' || s === 'overallScore' || s === 'totalScore'
      )

      topicAndSubtopics.forEach(item => {
        acc.push({
          title: (
            <div style={{ width: '90%' }}>
              {mainTopic === item ? originalTopic : formatSubTopicLabel(item)}
            </div>
          ),
          dataIndex:
            mainTopic === item
              ? originalTopic
              : `${item}roundToSort:${originalTopic}`,
          key:
            mainTopic === item
              ? `${originalTopic}roundToSort:${originalTopic}`
              : `${item}roundToSort:${originalTopic}`,
          width: '100px',
          sorter: true,
          align: 'center',
          hidden:
            (item === mainTopic && hasOverallSubTopic) ||
            (item !== mainTopic && expand) ||
            stage === 'offer',
          className: item === mainTopic ? 'last-ant-table-current-round' : '',
          render: (_, rowData) => {
            // For an assessment-mapped round, scores are only meaningful once
            // the candidate has completed the assessment. Until then (Invite
            // Pending / Pending / Dropped Off) show "NA" instead of a
            // misleading 0. Sheet/manual rounds keep their existing behaviour.
            const isAssessmentRound =
              candidateDeatils?.assessmentStatusColumn &&
              originalTopic === stage
            if (
              isAssessmentRound &&
              rowData?.assessment_status !== 'Completed'
            ) {
              return <div>NA</div>
            }
            let score
            if (item === mainTopic) {
              score =
                rowData?.average_rounds_score?.[originalTopic]?.toString() &&
                Number(rowData?.average_rounds_score?.[originalTopic]) != 0
                  ? Number(
                      rowData.average_rounds_score[originalTopic]
                    )?.toFixed(2)
                  : '0'
            } else {
              const raw = rowData?.parameters_score?.[originalTopic]?.[item]
              if (raw === undefined || raw === null || raw === '') {
                score = '0'
              } else if (typeof raw === 'string') {
                // Non-numeric sub-topics like cefrLevel (e.g. "A1", "B2", "-")
                score = raw
              } else {
                score =
                  Number(raw) != 0 ? Number(raw)?.toFixed(2) : '0'
              }
            }
            return <div>{score}</div>
          },
        })
      })

      return acc
    }, []),
  ].filter(item => !item.hidden)

  let checkData
  const onData = (selectedRowKeys, selectedRows) => {
    setSelectedCandidateId(selectedRowKeys)
    setSelectedCandidate(selectedRows)
    if (candidateDeatils?.totalPage > 1 && checkData === undefined) {
      setWholeSelect(false)
    }
  }
  const rowSelection = {
    selectedRowKeys: selectedCandidateId || [],
    onChange: (selectedRowKeys, selectedRows) => {
      onData(selectedRowKeys, selectedRows)
      setSelectedCandidateId(isAllSelected === true ? [] : selectedRowKeys)
      setSelectedCandidate(isAllSelected === true ? [] : selectedRows)
      setIsAllSelected(false)
    },
    onSelectAll: (selected, selectedRows) => {
      setIsAllSelected(false)
      setWholeSelect(selected)
      checkData = selectedRows.length
    },
    preserveSelectedRowKeys: true,
    getCheckboxProps: record => {
      const isScheduled = record?.isDisabled
      const os = record?.offerStatus
      const rawOs = record?.studentOfferStatus
      const rs = record?.status
      const TERMINAL_OFFER = ['ACCEPTED', 'JOINED', 'LEFTED', 'RELEASED', 'REJECTED']
      const hasProgressedToOffer =
        stage !== 'offer' &&
        stage !== 'all_candidates' &&
        rawOs !== 'NOT_RELEASED' &&
        (
          TERMINAL_OFFER.includes(os) ||
          (os === 'SHORTLISTED' && (rs === 'SELECTED' || rs === 'REJECT'))
        )

      return {
        disabled: isScheduled || hasProgressedToOffer,
      }
    },
  }

  const handleFilterChange = async (value, key) => {
    setFilterValues(prev => ({
      ...prev,
      [key]: value,
    }))
if(key === 'selectedRound'){
    const config = filterConfigs.find(item => item.key === 'selectedStatus')
    if (!config) return
    const selectedRoundString = filterOptions?.roundList?.filter(item => value.includes(item.value))?.map(item => item.name)?.join(',')
  
     
        const status = await getStatus(roleId, selectedRoundString)
        // Transform SELECTED to Intent To Offer, and REJECTED to Offer Declined in offer context
        const isOfferContext =  selectedRoundString.includes('offer')
        const transformedStatus = status.map(item => {
          let nextName = item.name
          if (nextName === 'SELECTED') nextName = 'Intent To Offer'
          if (isOfferContext && nextName === 'REJECTED') nextName = 'Offer Declined'
          if (nextName === 'TO_BE_UPDATED') nextName = 'To be updated'
          return nextName === item.name ? item : { ...item, name: nextName }
        })
        setFilterOptions(prev => ({
          ...prev,
          ['statusList']: transformedStatus,
        }))  
}
    if (key === 'selectedDegrees') {
      const config = filterConfigs.find(item => item.key === key)
      if (!config) return
      const degreeIdsString = value.join(',')
      const payload = {
        forStream: true,
        degreeIds: degreeIdsString,
        stage: stage,
      }

      let apiCall = config.api(roleId, stage, payload)
      const data =
        typeof apiCall === 'function' ? await apiCall() : await apiCall
      const getdata = data.map((item, index) => {
        let children = item.degreeStreamMap.map((stream, streamIndex) => {
          return {
            value: item?.id + ' ' + stream.stream.id,
            departId: stream.stream.id,
            title: stream.stream.name,
            nameValue: `Department - ${stream.stream.name}`,
            role: 'Department',
            degreeId: item.id,
          }
        })
        return {
          value: item.id,
          degreeId: item.id,
          title: item.name,
          children: children,
        }
      })
      const departSelect = [
        {
          title: 'Select All',
          value: 'Select All',
          children: getdata,
        },
      ]

      setFilterOptions(prev => ({
        ...prev,
        ['departList']: departSelect,
      }))
      if (value.length === 0) {
        setFilterValues(prev => ({
          ...prev,
          ['selectedDepartments']: [],
          ['selectedSpecialisations']: [],
        }))
      }
    }
    if (key === 'selectedDepartments') {
      const config = filterConfigs.find(item => item.key === key)
      if (!config) return
      const degreeIdsArray = filterValues.selectedDegrees
      // Flatten and split value array if any items contain space-separated values
      const allStreamIds = value.flatMap(v => v.split(' '))
      const filteredStreamIds = allStreamIds.filter(
        id => !degreeIdsArray.includes(id)
      )
      const payload = {
        forSpecialisation: true,
        degreeIds: degreeIdsArray.join(','),
        streamIds: filteredStreamIds.join(','),
        stage: stage,
      }
      let apiCall = config.api(roleId, stage, payload)
      const data =
        typeof apiCall === 'function' ? await apiCall() : await apiCall
      const splData = data.map(item => {
        let degreeChildren = item.degreeStreamMap.map(stream => {
          let specialisationChildren = stream.specialisationMasterStreamMap.map(
            specialisation => {
              return {
                value: `${stream.stream.id} ${specialisation.specialisationMaster.id}`,
                specialisationId: specialisation.specialisationMaster.id,
                title: specialisation.specialisationMaster.name,
                nameValue: `Specialisation - ${specialisation.specialisationMaster.name}`,
                role: 'Specialisation',
                degreeId: item.id,
                departId: stream.stream.id,
              }
            }
          )

          return {
            value: item.id + ' ' + stream.stream.id,
            departId: stream.stream.id,
            title: stream.stream.name,
            nameValue: `Department - ${stream.stream.name}`,
            role: 'Department',
            degreeId: item.id,
            children: specialisationChildren,
          }
        })

        return {
          value: item.id,
          degreeId: item.id,
          title: item.name,
          nameValue: `Degree - ${item.name}`,
          role: 'Degree',
          children: degreeChildren,
        }
      })

      // Check if splData has Specialisation data
      const hasSpecialisationData = splData.some(degree => 
        degree.children?.some(department => 
          department.children?.some(specialisation => 
            specialisation.role === 'Specialisation'
          )
        )
      )
      
      const splSelect = hasSpecialisationData ? [
        {
          title: 'Select All',
          value: 'Select All',
          children: splData,
        },
      ] : []
      setFilterOptions(prev => ({
        ...prev,
        ['splList']: splSelect,
      }))
    }
  }

  const handleFilterSearch = useCallback(
    debounce((value, key) => {
      fetchSearch(key, value)
    }, 300),
    []
  )

  const handleSelectAllClick = () => {
    setIsAllSelected(true)
  }
  const handleClearAllClick = () => {
    setIsAllSelected(false)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setWholeSelect(false)
  }
const onChangeStatusOffer = async (data, dateValue = null) => {
  // Check if status is JOINED or LEFTED and no date provided, show modal
  if ((data === 'JOINED' || data === 'LEFTED') && !dateValue) {
    setDatePickerModal({
      visible: true,
      status: data,
      selectedDate: null,
    })
    return
  }

  let payLoad = {
    forAllCandidate: false,
    status: 'SELECTED',
    stage: 'offer',
    offerStatus: data,
    filterStatus: status === 'ACTIVE' ? [] : status,
  }

  // Add date to payload if provided
  if (dateValue) {
    if (data === 'JOINED') {
      payLoad.joinedDate = moment(dateValue).format('YYYY-MM-DD')
    } else if (data === 'LEFTED') {
      payLoad.relievedDate = moment(dateValue).format('YYYY-MM-DD')
    }
  }

  if (
    Array.isArray(payLoad?.filterStatus) &&
    payLoad?.filterStatus?.length === 0
  ) {
    delete payLoad.filterStatus
  }
  const targetStudentIds = isAllSelected
    ? await fetchBulkStudentIds()
    : rowSelection.selectedRowKeys
  if (isAllSelected && (!targetStudentIds || targetStudentIds.length === 0)) {
    return
  }
  payLoad['studentId'] = targetStudentIds
  let response = await getNewIndividualDriveStatus(
    driveId,
    roleId,
    payLoad,
    getCandidateList
  )
  if (response?.status >= 200 && response?.status <= 300) {
    getDriveRoleMetrics(driveId)
    getRoleMetrics(driveId, roleId)
    setSelectedCandidate([])
    setIsAllSelected(false)
    // Close modal if open
    setDatePickerModal({
      visible: false,
      status: null,
      selectedDate: null,
    })
  }
}
  const onChangeStatus = async data => {
    if (data !== 'SHORTLISTED') {
      let payLoad = {
        forAllCandidate: false,
        status: data,
        stage: stage === null ? 'all_candidates' : stage,
        filterStatus: status === 'ACTIVE' ? [] : status,
      }
      if (
        Array.isArray(payLoad?.filterStatus) &&
        payLoad?.filterStatus?.length === 0
      ) {
        delete payLoad.filterStatus
      }
      const targetStudentIds = isAllSelected
        ? await fetchBulkStudentIds()
        : rowSelection.selectedRowKeys
      if (isAllSelected && (!targetStudentIds || targetStudentIds.length === 0)) {
        return
      }
      payLoad['studentId'] = targetStudentIds
      let response = await getNewIndividualDriveStatus(
        driveId,
        roleId,
        payLoad,
        getCandidateList
      )
      if (response?.status >= 200 && response?.status <= 300) {
        getDriveRoleMetrics(driveId)
        getRoleMetrics(driveId, roleId)

        // Send rejection email when status is REJECTED
        if (data === 'REJECTED') {
          const currentRoundName = stage || ''
          const roleName = rolesMetrics?.[0]?.roleName || ''
          const emailPayload = selectedCandidate
            ?.filter(item => item?.student?.studentPersonalProfile?.primaryEmail)
            ?.map(item => {
              const studentName = item?.student?.firstName || ''
              const htmlBody = ReactDOMServer.renderToString(
                <RejectionTemplate
                  data={{
                    studentName,
                    companyName: corporateData?.name || '',
                    roleName,
                    roundName: currentRoundName,
                    signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
                    signatureRole: userData?.role || 'PluginLive',
                  }}
                />
              )
              return {
                to: item?.student?.studentPersonalProfile?.primaryEmail,
                subject: `Update: ${currentRoundName} Status`,
                htmlBody,
              }
            })
          if (emailPayload?.length > 0) {
            dispatch(sendNotificationBulkEmail(emailPayload))
          }

          // WhatsApp: corporate_reject — hidden per request
          // const rejectWaPayload = selectedCandidate
          //   ?.filter(item => item?.student?.studentPersonalProfile?.phoneNumber)
          //   ?.map(item => ({
          //     to: item?.student?.studentPersonalProfile?.phoneNumber,
          //     templateName: 'corporate_reject',
          //     type: 'template',
          //     components: [
          //       {
          //         type: 'BODY',
          //         index: 0,
          //         sub_type: 'CATALOG',
          //         parameters: [
          //           { type: 'TEXT', text: item?.student?.firstName || '' },
          //           { type: 'TEXT', text: currentRoundName },
          //           { type: 'TEXT', text: roleName },
          //           { type: 'TEXT', text: corporateData?.name || '' },
          //         ],
          //       },
          //     ],
          //   }))
          // if (rejectWaPayload?.length > 0) {
          //   dispatch(sendNotificationBulkEmailWhatsapp(rejectWaPayload))
          // }
        }

        setSelectedCandidate([])
        setIsAllSelected(false)
      }
    } else {
      nextRoundFunction()
      setIsModalOpen(true)
    }
  }

  const handleDownload = async () => {
    if (selectedCandidate.length <= 10 && !isAllSelected) {
      setActionDrawer(true)
      setStudentListId(rowSelection.selectedRowKeys)
    } else {
      setBulkDownload(true)
    }
  }
  const handlePageChange = pageNum => {
    setConflictFilter({ ...conflictFilter, page: pageNum - 1 })
  }
  const handleSearch = e => {
    const value = e?.target?.value || e
    setConflictFilter({ ...conflictFilter, search: value })
  }
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(conflictFilter.search)
      setConflictFilter({ ...conflictFilter, page: 0 })
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [conflictFilter.search])
  const handleShortListBtn = async (conflictId, roleId) => {
    setISLoading(true)
    const payload = {}
    const response = await updateResolveConflictCandidates(
      roleId,
      conflictId,
      payload
    )
    if (response.status === 200) {
      setConflictDrawer(false)
      setISLoading(false)
      await getDriveRoleMetrics(driveId)
      await getRoleMetrics(driveId, roleId)
      let currentFilterPayload = selectedFilterValue || {}
      const hasFilters = currentFilterPayload && Object.keys(currentFilterPayload).length > 0
      currentFilterPayload = hasFilters ? currentFilterPayload : {}
      await getCandidateList(currentFilterPayload, currentPage)
    } else {
      setISLoading(false)
      setErrorMessage(response?.data?.message)
    }
  }
  const ConflictColumn = [
    {
      width: 140,
      title: 'Uploaded Data',
      dataIndex: 'Uploaded Data',
      key: 'Uploaded Data',
      className: 'uploaded-data',
      render: (text, record) => {
        const { email, lastName, firstName, phoneNumber } =
          record.uploadedCandidateData
        const disable = record.candidateDetails.every(
          item =>
            item.primaryEmail?.toLowerCase()?.trim() ===
            email?.toLowerCase()?.trim()
        )
        const nameDisable = record.candidateDetails.every(
          item =>
            item?.student?.firstName?.toLowerCase()?.trim() ===
            firstName?.toLowerCase()?.trim()
        )
        const lastDisable = record.candidateDetails.every(
          item =>
            item?.student?.lastName?.toLowerCase()?.trim() ===
            lastName?.toLowerCase()?.trim()
        )
        const phoneDisable = record?.candidateDetails?.every(
          item => item?.contactNumber?.trim() === phoneNumber?.trim()
        )
        return (
          <Tooltip
            title={
              <div>
                {firstName}
                {lastName}
                <br />
                {phoneNumber}
                <br />
                {email}
              </div>
            }
          >
            <TextEllipse disable={nameDisable}>
              {firstName}{' '}
              <span
                style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
              >
                {lastName}
              </span>
            </TextEllipse>

            <ConflictName disable={phoneDisable}>{phoneNumber}</ConflictName>
            <ConflictName disable={disable}>{email}</ConflictName>
          </Tooltip>
        )
      },
      onCell: (record, index) => {
        const rowSpan =
          record.candidateDetails.length == 0
            ? 1
            : record.candidateDetailIndex === 0
            ? record.candidateDetails.length
            : 0
        return { rowSpan }
      },
    },
    {
      width: 140,
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { firstName, lastName } = record?.candidateDetail || {}

        const disable =
          record?.uploadedCandidateData?.firstName?.toLowerCase()?.trim() ===
          firstName?.toLowerCase()?.trim()

        const lastDisable =
          record?.uploadedCandidateData?.lastName?.toLowerCase()?.trim() ===
          lastName?.toLowerCase()?.trim()

        //display

        const firstStudentName = firstName?.trim() ? toCamelCase(firstName) : ''
        const lastStudentName = lastName?.trim() ? toCamelCase(lastName) : ''

        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {firstStudentName} {lastStudentName}
                  </div>
                }
              >
                <ConflictName disable={disable} caps={true}>
                  {firstStudentName}{' '}
                  <span
                    style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
                  >
                    {lastStudentName}
                  </span>
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Contact details',
      dataIndex: 'Contact details',
      key: 'Contact details',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { primaryEmail, secondaryEmail, contactNumber } =
          record?.candidateDetail || {}
        const EmailDisable =
          primaryEmail?.toLowerCase()?.trim() ===
          record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
        const secondaryEmailDisable =
          secondaryEmail?.toLowerCase()?.trim() ===
          record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
        const phoneDisable =
          contactNumber?.trim() ===
          record?.uploadedCandidateData?.phoneNumber?.trim()

        //display
        let pEmail = primaryEmail ? primaryEmail?.toLowerCase() : primaryEmail
        let sEmail = secondaryEmail
          ? secondaryEmail?.toLowerCase()
          : secondaryEmail
        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {pEmail}
                    <br />
                    {sEmail}
                    <br />
                    {contactNumber}
                  </div>
                }
              >
                <ConflictName disable={EmailDisable}>{pEmail}</ConflictName>
                <ConflictName disable={secondaryEmailDisable}>
                  {sEmail}
                </ConflictName>
                <ConflictName disable={phoneDisable}>
                  {contactNumber}
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Degree & Department',
      dataIndex: 'Degree & Department',
      key: 'Degree & Department',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const degree = record?.candidateDetail?.degree ?? ''
        const department = record?.candidateDetail?.department ?? ''
        const Degree = degree?.trim() ? toCamelCase(degree) : ''
        const Department = department?.trim() ? toCamelCase(department) : ''
        return (
          <div style={{ textAlign: 'left' }}>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {Degree}
                    <br />
                    {Department}
                  </div>
                }
              >
                <ConflictName disable={true} caps={true}>
                  {Degree}
                </ConflictName>
                <ConflictName disable={true} caps={true}>
                  {Department}
                </ConflictName>
              </Tooltip>
            )}
          </div>
        )
      },
    },
    {
      width: 140,
      title: 'Move to',
      dataIndex: 'Move to',
      key: 'Move to',
      className: 'conflict-staus-action',
      render: (text, record) => {
        const disable = record.candidateDetail === null
        const isOfferStage = record.stage === 'offer' // check lowercase if your data uses it

        return (
          <>
            {!isOfferStage ? (
              <>
                <ShortList
                  disable={disable}
                  onClick={() => handleShortListBtn(record?.id, record?.jobId)}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '12px',
                    }}
                  >
                    <ArrowForward
                      color="#3249D7"
                      width="10"
                      height="10"
                      style={{ marginRight: '5px' }}
                    />
                    Round {record?.roundIndex}
                  </div>
                </ShortList>
                <div
                  style={{
                    fontSize: '12px',
                    color: '#000',
                    fontWeight: '500',
                    marginTop: '5px',
                    marginLeft: '20px',
                  }}
                >
                  {record?.nextRound}
                </div>
              </>
            ) : (
              <ShortList
                disable={disable}
                onClick={() => handleShortListBtn(record?.id, record?.jobId)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <ArrowForward
                    color="#3249D7"
                    width="14"
                    height="14"
                    style={{ marginRight: '5px' }}
                  />
                  {record?.nextRound}
                </div>
              </ShortList>
            )}
          </>
        )
      },
    },
  ]
  const handleClose = () => {
    setConflictDrawer(false)
    setConflictFilter({
      search: '',
      page: 0,
    })
  }

  const ConflictContent = () => {
    return (
      <ResolveConflict
        conflictData={conflictData}
        conflictFilter={conflictFilter}
        handlePageChange={handlePageChange}
        handleSearch={handleSearch}
        // handleShortListBtn={handleShortListBtn}
        isLoading={isLoading}
        columns={ConflictColumn}
      />
    )
  }
  const getConflict = async () => {
    try {
      setISLoading(true)
      const getConflictData = await getConflictCandidates(roleId, {
        search: conflictFilter.search,
        pageLimit: 10,
        pageNo: conflictFilter.page,
        roundId: roundId,
        stage: stage,
      })
      if (conflictFilter.search === '') {
        if (getConflictData?.count === 0) {
          setConflictDrawer(false)
        }
      }
      setISLoading(false)
      setConflictData(getConflictData)
    } catch (error) {
      ErrorMessage(error)
      setISLoading(false)
    }
  }
  useEffect(() => {
    getConflict()
  }, [stage, conflictFilter.page, debouncedSearch])
  const handleResolveConflict = async () => {
    setConflictDrawer(true)
    setConflictFilter({
      search: '',
      page: 0,
    })
    try {
      setISLoading(true)

      const getConflictData = await getConflictCandidates(roleId, {
        pageNo: 0,
        pageLimit: 10,
        roundId: roundId,
        stage: stage,
      })
      setISLoading(false)
      setConflictData(getConflictData)
    } catch (err) {
      ErrorMessage(err)
    }
  }

  useEffect(() => {
    if (isAllSelected && !isLoading) {
      const filteredRows = candidateDeatils?.result.filter(record => {
        return !record.isDisabled
      })
      const filteredRowKeys = filteredRows.map(item => item.student_id)
      setSelectedCandidateId(filteredRowKeys)
      setSelectedCandidate(filteredRows)
    }
  }, [isAllSelected, isLoading])

  useEffect(() => {
    let data = candidateDeatils?.panels
    let optionData = []
    let finalData = []
    let constantData = [
      {
        label: 'View All',
        value: 'all',
      },
    ]
    if (data?.length > 0) {
      optionData = data?.map(item => ({
        label: 'Panel ' + item?.panel,
        value: item?.panel?.toString(),
      }))

      finalData = [...constantData, ...optionData]
    }

    setPanelData(finalData)
  }, [candidateDeatils])

  const handleSelect = () => {
    const filteredRows = candidateDeatils?.result?.map(record => {
      const isScheduled = record?.isDisabled
        ? record?.isDisabled
        : record.status === 'SCHEDULED' ||
          record.status === 'TO_BE_UPDATED' ||
          (status == 'ACTIVE' && record.status === 'ABSENT') ||
          record.status == 'RESCHEDULED' ||
          (stage == 'offer' &&
            status == 'ACTIVE' &&
            offerStatusArr.includes(record.offerStatus))

      return {
        ...record,
        disabled: isScheduled,
      }
    })
    const filteredArr = filteredRows?.filter(item => !item?.disabled)

    let checking =
      candidateDeatils?.notDisabledCount > 0 && filteredArr.length === 0
    setEnableSelectAll(checking)
  }

  useEffect(() => {
    if (candidateDeatils?.result && !isLoading) {
      handleSelect()
    }
  }, [candidateDeatils, status, stage, offerStatusArr, isLoading])

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
  const onApplyFilters = () => {
    const filterPayload = {}

    if (filterValues?.selectedRound?.length > 0) {
      filterPayload.roundFilter = filterValues?.selectedRound
    }
    if (filterValues?.selectedStatus?.length > 0) {
      filterPayload.status = filterValues?.selectedStatus
    }
    if (filterValues?.selectedAssessmentStatus?.length > 0) {
      filterPayload.assessmentStatus = filterValues?.selectedAssessmentStatus
    }
    if (filterValues?.selectedYears?.length > 0) {
      filterPayload.yearOfPassing = filterValues?.selectedYears
    }
    if (filterValues?.selectedGender?.length > 0) {
      filterPayload.genderFilter = filterValues?.selectedGender
    }
    if (filterValues?.selectedSkills?.length > 0) {
      filterPayload.skillIds = filterValues?.selectedSkills
    }
    if (filterValues?.selectedColleges?.length > 0) {
      filterPayload.collegeIds = filterValues?.selectedColleges
    }
    if (filterValues?.selectedCollegeStates?.length > 0) {
      filterPayload.collegeStateIds = filterValues?.selectedCollegeStates
    }
    if (filterValues?.selectedCollegeCities?.length > 0) {
      filterPayload.collegeCityIds = filterValues?.selectedCollegeCities
    }
    if (filterValues?.selectedPermanentState?.length > 0) {
      filterPayload.permanentStateIds = filterValues?.selectedPermanentState
    }
    if (filterValues?.selectedPermanentCity?.length > 0) {
      filterPayload.permanentCityIds = filterValues?.selectedPermanentCity
    }
    if (filterValues?.selectedCurrentState?.length > 0) {
      filterPayload.currentStateIds = filterValues?.selectedCurrentState
    }
    if (filterValues?.selectedCurrentCity?.length > 0) {
      filterPayload.currentCityIds = filterValues?.selectedCurrentCity
    }
    if (filterValues?.selectedPreferredLocation?.length > 0) {
      filterPayload.preferredLocationIds =
        filterValues?.selectedPreferredLocation
    }
    if (filterValues?.selectedRole?.length > 0) {
      filterPayload.roles = filterValues?.selectedRole
    }
    if (filterValues?.selectedFunction?.length > 0) {
      filterPayload.functions = filterValues?.selectedFunction
    }

    if (filterValues?.selectScories?.length > 0) {
      const scoreObj = {}
      filterPayload.scoreFilterType = filterValues?.selectedScoreFilterType
      filterValues?.selectScories?.forEach(item => {
        if (item?.qualification?.value && item?.percentage !== undefined) {
          scoreObj[item?.qualification?.value] = item?.percentage
        }
      })

      filterPayload.score = scoreObj
    }

    if (filterValues?.selectedRoundScore?.length) {
      const dummyData = []

      let currentTopic = null

      data?.forEach(item => {
        if (item?.isTopic) {
          currentTopic = {
            topic: { name: item?.topic, score: 0 },
            subTopics: [],
          }
          if (item?.value !== '') {
            currentTopic.topic.score = Number(item?.value)
          }
          dummyData?.push(currentTopic)
        } else {
          let mainIndex
          const parts = item?.index?.split(',')
          if (parts?.length > 0) {
            mainIndex = Number(parts[0])
          }
          if (!currentTopic) return // Skip if there's no current topic

          if (item?.value !== '') {
            if (!Array?.isArray(currentTopic?.subTopics?.[mainIndex])) {
              currentTopic.subTopics[mainIndex] = []
            }
            currentTopic.subTopics[mainIndex].push({
              param: item.topic,
              // cefrLevel is ordinal (A1..C2) — keep the string; Number("A1")
              // would be NaN → null and silently drop the filter server-side.
              score:
                item.topic === 'cefrLevel' ? item.value : Number(item.value),
            })
          }
        }
      })

      dummyData.forEach(topic => {
        topic.subTopics = topic.subTopics
          .filter(subTopic => subTopic.length > 0)
          .flat()
      })

      let filteredData = dummyData?.filter(
        item => Object.keys(item.topic).length
      )

      filteredData.forEach(item => {
        if (item.subTopics && item.subTopics.length === 0) {
          delete item.subTopics
        }
      })
      filterPayload.mode = filterValues?.selectedRoundMode
        ? 'selection'
        : 'rejection'
      filterPayload.scores = filteredData
    }

    if (
      filterValues?.selectedDegrees?.length > 0 &&
      filterOptions?.degreeList?.[0]?.children?.length > 0
    ) {
      let degrees = filterOptions?.degreeList?.[0]?.children
        .filter(item => filterValues?.selectedDegrees?.includes(item?.value))
        .map(item => ({
          domain: item?.title,
          domainId: item?.domainId,
          value: item?.value,
          nameValue: `Degree - ${item?.title}`,
          role: 'Degree',
        }))
      filterPayload.degreeId = degrees
    }
    if (
      filterValues?.selectedDepartments?.length > 0 &&
      filterOptions?.departList?.[0]?.children?.length > 0
    ) {
      const selectedDepartmentValues = filterValues?.selectedDepartments

      const departments = filterOptions?.departList?.[0]?.children?.flatMap(
        degree =>
          degree?.children
            .filter(child => selectedDepartmentValues?.includes(child?.value))
            .map(child => ({
              departId: child?.departId,
              title: child?.title,
              value: child?.value,
              nameValue: `Department - ${child?.title}`,
              role: 'Department',
              degreeId: child?.degreeId,
            }))
      )

      filterPayload.departId = departments
    }
    if (
      filterValues?.selectedSpecializations?.length > 0 &&
      filterOptions?.splList?.[0]?.children?.length > 0
    ) {
      let specializations = filterOptions?.splList?.[0]?.children?.flatMap(
        degree =>
          degree?.children?.flatMap(department =>
            department?.children
              .filter(spec =>
                filterValues?.selectedSpecializations?.includes(spec?.value)
              )
              .map(spec => ({
                specialisationId: spec?.specialisationId,
                title: spec?.title,
                value: spec?.value,
                nameValue: `Specialisation - ${spec?.title}`,
                role: 'Specialisation',
                degreeId: spec?.degreeId,
                departId: spec?.departId,
              }))
          )
      )

      filterPayload.specialisationId = specializations
    }
    if (filterValues?.selectedAge || filterValues?.selectedQuickAge) {
      const toInt = v => {
        const n = parseInt(v, 10)
        return Number.isFinite(n) ? n : 0
      }
      if (filterValues?.selectedAge?.from || filterValues?.selectedAge?.to) {
        filterPayload.fromAge = toInt(filterValues?.selectedAge?.from)
        filterPayload.toAge = toInt(filterValues?.selectedAge?.to)
        // Strict mode: also send total-month bounds so the backend compares
        // years AND months (e.g. To 22y0m excludes 22y5m).
        if (filterValues?.selectedAge?.strict) {
          filterPayload.strictAge = true
          filterPayload.fromAgeMonths =
            toInt(filterValues?.selectedAge?.from) * 12 +
            toInt(filterValues?.selectedAge?.fromMonths)
          filterPayload.toAgeMonths =
            toInt(filterValues?.selectedAge?.to) * 12 +
            toInt(filterValues?.selectedAge?.toMonths)
        }
      }
      if (
        filterValues?.selectedQuickAge?.from ||
        filterValues?.selectedQuickAge?.to
      ) {
        filterPayload.fromAge = toInt(filterValues?.selectedQuickAge?.from)
        filterPayload.toAge = toInt(filterValues?.selectedQuickAge?.to)
      }
    }
    if (filterValues?.includeArrears === false) {
      if (
        filterValues?.selectedCurrentArrearFilterType !== '' &&
        filterValues?.selectedCurrentArrearCount !== null &&
        filterValues?.selectedCurrentArrearCount !== '' &&
        filterValues?.selectedCurrentArrearFilterType !== null
      ) {
        filterPayload.currentArrearCount =
          filterValues?.selectedCurrentArrearCount
        filterPayload.currentArrearCondition =
          filterValues?.selectedCurrentArrearFilterType
      }
      if (
        filterValues?.selectedPastArrearFilterType !== '' &&
        filterValues?.selectedPastArrearCount !== null &&
        filterValues?.selectedPastArrearCount !== '' &&
        filterValues?.selectedPastArrearFilterType !== null
      ) {
        filterPayload.historyArrearCount = filterValues?.selectedPastArrearCount
        filterPayload.historyArrearCondition =
          filterValues?.selectedPastArrearFilterType
      }
    } else {
      filterPayload.noArrears = filterValues?.includeArrears
    }
    if (filterValues?.selectedQualifyingQuestions?.length > 0) {
      filterPayload.questionFilter = filterValues?.selectedQualifyingQuestions
    }
    if (filterValues?.selectedCustomQuestions?.length > 0) {
      filterPayload.customQuestions = filterValues?.selectedCustomQuestions
    }
    if (
      filterValues?.selectedAppliedDateRange?.length === 2 &&
      filterValues?.selectedAppliedDateRange[0] &&
      filterValues?.selectedAppliedDateRange[1]
    ) {
      // applied_date is stored as a naive UTC timestamp; send UTC wall-clock
      // strings so the backend can compare against it directly (::timestamp).
      filterPayload.appliedDateFrom = moment(
        filterValues?.selectedAppliedDateRange[0]
      )
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
      filterPayload.appliedDateTo = moment(
        filterValues?.selectedAppliedDateRange[1]
      )
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
    }
    setSelectedFilterValue(filterPayload)
    setCurrentPage(0)
    getCandidateList(filterPayload, 0)
    setIsMenuOpen(false)
  }

  const handleConfirm = async () => {
    let payLoad = {
      forAllCandidate: false,
      status: 'TO_BE_SCHEDULED',
      stage: stage === null ? 'all_candidates' : stage,
      filterStatus: status === 'ACTIVE' ? [] : status,
      nextStage: popSelectedRound,
    }
    if (
      Array.isArray(payLoad?.filterStatus) &&
      payLoad?.filterStatus?.length === 0
    ) {
      delete payLoad.filterStatus
    }
    let targetStudentIds
    if (isAllSelected) {
      targetStudentIds = await fetchBulkStudentIds()
      if (!targetStudentIds || targetStudentIds.length === 0) {
        return
      }
    } else {
      targetStudentIds = rowSelection.selectedRowKeys?.length > 0
        ? rowSelection.selectedRowKeys
        : candidateInfoData?.student?.id
          ? [candidateInfoData.student.id]
          : []
    }
    payLoad['studentId'] = targetStudentIds
    let response = await getNewIndividualDriveStatus(
      driveId,
      roleId,
      payLoad,
      getCandidateList
    )
    if (response?.status >= 200 && response?.status <= 300) {
      setIsModalOpen(false)
      getDriveRoleMetrics(driveId)
      getRoleMetrics(driveId, roleId)

      // Send "Moved to Next Round" email to selected candidates
      const currentRoundName = stage || ''
      const nextRoundName = popSelectedRound || ''
      
      // Determine target candidates for notifications - use selectedCandidate if available, otherwise use candidateInfoData (from drawer)
      const targetCandidates = selectedCandidate?.length > 0 
        ? selectedCandidate 
        : candidateInfoData?.student 
          ? [candidateInfoData] 
          : []
      
      // Email + WhatsApp for "Moved to Next Round" — hidden per request
      // const emailPayload = targetCandidates
      //   ?.filter(item => item?.student?.studentPersonalProfile?.primaryEmail)
      //   ?.map(item => {
      //     const studentName = item?.student?.firstName || ''
      //     const htmlBody = ReactDOMServer.renderToString(
      //       <MoveToNextRoundTemplate
      //         data={{
      //           studentName,
      //           companyName: corporateData?.name || '',
      //           currentRound: currentRoundName,
      //           nextRound: nextRoundName,
      //           signatureName: (userData?.first_name || '') + (userData?.last_name ? ' ' + userData?.last_name : ''),
      //           signatureRole: userData?.role || 'PluginLive',
      //         }}
      //       />
      //     )
      //     return {
      //       to: item?.student?.studentPersonalProfile?.primaryEmail,
      //       subject: 'Moved to Next Round',
      //       htmlBody,
      //     }
      //   })
      // if (emailPayload?.length > 0) {
      //   dispatch(sendNotificationBulkEmail(emailPayload))
      // }

      // WhatsApp: corporate_next_round — hidden per request
      // const nextRoundWaPayload = targetCandidates
      //   ?.filter(item => item?.student?.studentPersonalProfile?.phoneNumber)
      //   ?.map(item => ({
      //     to: item?.student?.studentPersonalProfile?.phoneNumber,
      //     templateName: 'corporate_next_round',
      //     type: 'template',
      //     components: [
      //       {
      //         type: 'BODY',
      //         index: 0,
      //         sub_type: 'CATALOG',
      //         parameters: [
      //           { type: 'TEXT', text: item?.student?.firstName || '' },
      //           { type: 'TEXT', text: nextRoundName },
      //           { type: 'TEXT', text: rolesMetrics?.[0]?.roleName || '' },
      //           { type: 'TEXT', text: corporateData?.name || '' },
      //         ],
      //       },
      //     ],
      //   }))
      // if (nextRoundWaPayload?.length > 0) {
      //   dispatch(sendNotificationBulkEmailWhatsapp(nextRoundWaPayload))
      // }

      setSelectedCandidate([])
      setCandidateInfoData({}) // Clear the drawer candidate data as well
      setIsAllSelected(false)
    }
  }

  const candidateStatus = selectedCandidate?.map(item => item.status)
  // Helper functions for status selection
  const isActionDisabled = actionStatuses => {
    return (
      actionStatuses.some(value => candidateStatus?.includes(value)) ||
      selectedCandidateId?.length === 0
    )
  }

  const getActionStyle = actionStatuses => ({
    pointerEvents: isActionDisabled(actionStatuses) ? 'none' : '',
    opacity: isActionDisabled(actionStatuses) ? '0.5' : '',
  })

  const renderStatusAction = (actionType, actionStatuses, icon) => {
    const shouldShow =
      actionType === 'SHORTLISTED'
        ? status !== 'ABSENT' && status !== 'ACCEPTED'
        : status !== 'REJECTED' && status !== 'ABSENT'

    if (!shouldShow) return null

    const tooltipTitle = stage === 'all_candidates' && actionType === 'SHORTLISTED' ? 'Move to Evaluation Process' : actionType === 'SHORTLISTED' ? 'Shortlist' : 'Reject'
    const isDisabled = isActionDisabled(actionStatuses)

    return (
      <Tooltip title={tooltipTitle}>
        <EmptyElement
          onClick={isDisabled ? undefined : () => onChangeStatus(actionType)}
          style={{
            ...getActionStyle(actionStatuses),
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            // Keep pointerEvents as 'auto' for tooltip to work even when disabled
            pointerEvents: 'auto',
          }}
        >
          {icon}
        </EmptyElement>
      </Tooltip>
    )
  }
  return (
    <>
      <IndividualDriveFilter
        roundName={roundName}
        newDriveStatusData={newDriveStatusData}
        newDriveScoreData={newDriveScoreData}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        candidateRating={candidateRating}
        setCandidateRating={setCandidateRating}
        checkedKeys={checkedKeys}
        setCheckedKeys={setCheckedKeys}
        interviewRound={interviewRound}
        setInterviewRound={setInterviewRound}
        checkedIds={checkedIds}
        setCheckedIds={setCheckedIds}
        getCandidateList={getCandidateList}
        rolesMetrics={rolesMetrics}
        degreeList={degreeList}
        setSearchParams={setSearchParams}
        collegeList={collegeList}
        college={college}
        setCollege={setCollege}
        setCollegeSearch={setCollegeSearch}
        status={status}
        setStatus={setStatus}
        currentCount={
          candidateDeatils?.result?.count < 10
            ? candidateDeatils?.result?.length
            : (candidateDeatils?.page + 1) * 10 -
              10 +
              candidateDeatils?.result?.length
        }
        totalCount={candidateDeatils?.count}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
        setReleaseOffer={setReleaseOffer}
        currentTab={currentTab}
        singleRoleData={singleRoleData}
        setSelectedCandidate={setSelectedCandidate}
        setSelectedCandidateId={setSelectedCandidateId}
        CandidateFilter={false}
        setScorePayload={setScorePayload}
        stage={stage}
        setSelectedFilterValue={setSelectedFilterValue}
        selectedFilterValue={selectedFilterValue}
        setCurrentPage={setCurrentPage}
        filterOptions={filterOptions}
        filterValues={filterValues}
        setFilterValues={setFilterValues}
        setFilterOptions={setFilterOptions}
        handleFilterChange={handleFilterChange}
        handleFilterSearch={handleFilterSearch}
        scoreFilterRef={scoreFilterRef}
        onApplyFilters={onApplyFilters}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        data={data}
        setData={setData}
        selectedQuickOption={selectedQuickOption}
        setSelectedQuickOption={setSelectedQuickOption}
        showAssessmentStatusFilter={candidateDeatils?.assessmentStatusColumn}
      />
      {stage === 'all_candidates' || stage === 'offer' || stage === null ? (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'start',
              marginTop: '1em',
              marginBottom: '1em',
              marginLeft: '1em',
            }}
          >
            {stage === 'offer' && (
              <OfferTableStatusIcon 
                status={status}
                stage={stage}
                selectedCandidateId={selectedCandidateId}
                candidateStatus={candidateStatus}
                onChange={onChangeStatusOffer}
                handleDownload={handleDownload}
                conflictData={conflictData}
                handleResolveConflict={handleResolveConflict}
                filterValues={filterValues}
              />
              // <div
              //   style={{
              //     display: 'flex',
              //     justifyContent: 'space-between',
              //     alignItems: 'start',
              //     width: '100%',
              //   }}
              // >
              //   <div
              //     onClick={
              //       selectedCandidate.length > 0
              //         ? () => handleDownload()
              //         : undefined
              //     }
              //     style={{
              //       opacity: selectedCandidate.length > 0 ? 1 : 0.5,
              //       pointerEvents:
              //         selectedCandidate.length > 0 ? 'auto' : 'none',
              //       cursor:
              //         selectedCandidate.length > 0 ? 'pointer' : 'not-allowed',
              //     }}
              //   >
              //     <ResumeDownload />
              //   </div>
              //   <div
              //     style={{
              //       justifyContent: 'flex-end',
              //       alignItems: 'end',
              //       gap: '10px',
              //       flex: '0 0 auto',
              //       fontSize: '16px',
              //       marginRight: '10px',
              //     }}
              //   >
              //     <Button.Danger
              //       wordBreak
              //       text={'Resolve Conflicts'}
              //       onClick={() => handleResolveConflict()}
              //       disable={conflictData?.count === 0}
              //     />
              //   </div>
              // </div>
            )}
            {(stage === 'all_candidates' || stage === null) && (
              <IconContainer
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  width: '100%',
                }}
              >
                {/* Left side: Select Status Icons */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '20px',
                    flex: '0 0 auto',
                  }}
                >
                  <IconText style={{ whiteSpace: 'nowrap' }}>
                    Select status
                  </IconText>
                  {renderStatusAction(
                    'SHORTLISTED',
                    ['ABSENT', 'TO_BE_UPDATED', 'SHORTLISTED'],
                    <SelectTickIcon width={20} height={20} />
                  )}
                  {renderStatusAction(
                    'REJECTED',
                    ['ABSENT', 'REJECTED', 'TO_BE_UPDATED'],
                    <RejectIcon width={20} height={20} />
                  )}

                  {/* Resume Download */}
                  <StyledDivider type="vertical" />
                  <EmptyElement
                    onClick={
                      selectedCandidateId?.length === 0
                        ? undefined
                        : () => handleDownload()
                    }
                    style={{
                      pointerEvents: 'auto',
                      opacity:
                        selectedCandidateId?.length === 0
                          ? '0.5'
                          : '',
                    }}
                  >
                    <ResumeDownload />
                  </EmptyElement>

                  {/* Filter Count */}
                  {filterValues && getActiveFilterCount(filterValues) > 0 && (
                    <>
                      <StyledDivider type="vertical" />
                      <IconText style={{ whiteSpace: 'nowrap' }}>Selected Filter Count: {getActiveFilterCount(filterValues)}</IconText>
                    </>
                  )}
                </div>

                {/* Right side: Button */}
                {stage !== 'all_candidates' && stage !== 'offer' && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '10px',
                    flex: '0 0 auto',
                    fontSize: '16px',
                  }}
                >
                  <Button.Danger
                    wordBreak
                    text={'Resolve Conflicts'}
                    onClick={() => handleResolveConflict()}
                    disable={conflictData?.count === 0}
                  />
                  <Button.Secondary
                    wordBreak
                    text={'+ Select Assessment'}
                    onClick={() => setSelectAssessmentDrawerOpen(true)}
                  />
                </div>
                )}
              </IconContainer>
            )}
          </div>
          { stage !== 'all_candidates' && stage !== 'offer' && (
            <SelectAssessmentDrawer
              driveId={driveId}
              roleId={roleId}
              round={stage}
              corporateId={corporateData?.id}
              open={selectAssessmentDrawerOpen}
              onClose={() => setSelectAssessmentDrawerOpen(false)}
              onMappingChange={() => {
                if (typeof getCandidateList === 'function') {
                  const currentFilterPayload = selectedFilterValue || {}
                  getCandidateList(currentFilterPayload, currentPage)
                }
              }}
            />
          )}
        </>
      ) : (
        <>
          <StyledDivider />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent:
                status !== 'SCHEDULED,TO_BE_SCHEDULED' &&
                status !== 'RESCHEDULED,RESCHEDULE'
                  ? 'space-between'
                  : 'flex-end',
              height: '4em',
            }}
          >
            {status !== 'SCHEDULED,TO_BE_SCHEDULED' &&
              status !== 'RESCHEDULED,RESCHEDULE' && (
                <TableStatusIcon
                  status={status}
                  stage={stage}
                  onChange={onChangeStatus}
                  round={selectedRoundType?.type}
                  candidateStatus={candidateStatus}
                  selectedCandidateId={selectedCandidateId}
                  handleDownload={handleDownload}
                  conflictData={conflictData}
                  handleResolveConflict={handleResolveConflict}
                  filterValues={filterValues}
                  setSelectAssessmentDrawerOpen={setSelectAssessmentDrawerOpen}
                />
              )}

            <div
              style={{
                display: 'flex',
                gap: '1em',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {panelData !== '' &&
                panelData?.length > 0 &&
                stage !== 'offer' && (
                  <>
                    <div id={tabIndex + 'panel_popup'}>
                      <StyledSelect
                        showSearch
                        placeholder="Select a panel"
                        optionFilterProp="children"
                        filterOption={filterOption}
                        options={panelData || []}
                        key={panelValue}
                        height="38px !important"
                        width="150px"
                        value={panelValue}
                        valueParam="value"
                        nameParam="label"
                        onChange={(value, Option) => {
                          setPanelValue(value)
                        }}
                        getPopupContainer={() =>
                          document.getElementById(tabIndex + 'panel_popup')
                        }
                        id="panel"
                        style={{
                          width: '7em',
                          height: '2.6em',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '5px',
                        }}
                      />
                    </div>
                    <PanelDrawer
                      driveId={driveId}
                      roleId={roleId}
                      getPanelList={getPanelList}
                      roundName={stage}
                      panelData={panelValue}
                    />
                  </>
                )}

              {(selectedTab?.key == 'SCHEDULED,TO_BE_SCHEDULED' ||
                selectedTab?.key == 'RESCHEDULED,RESCHEDULE') && (
                <Button.Secondary
                  text={
                    selectedTab?.key == 'SCHEDULED,TO_BE_SCHEDULED'
                      ? 'Schedule'
                      : 'Re-Schedule'
                  }
                  height={'38px'}
                  onClick={() => {
                    setScheduleDrawer(true)
                  }}
                  disabled={
                    (rowSelection?.selectedRowKeys.length <= 1 &&
                      selectedRoundType?.type == 'GROUP') ||
                    rowSelection?.selectedRowKeys.length <= 0
                  }
                />
              )}
            </div>
          </div>
        </>
      )}
      {(selectedCandidate?.length !== 0 || isAllSelected) &&
        wholeSelect &&
        candidateDeatils?.totalPage > 1 &&
        (candidateDeatils?.notDisabledCount > 0 || candidateDeatils?.count > 0) &&
        !isLoading && (
          <SelectionDisplay
            selectedCandidate={selectedCandidate}
            candidateDeatils={candidateDeatils}
            isAllSelected={isAllSelected}
            handleSelectAllClick={handleSelectAllClick}
            handleClearAllClick={handleClearAllClick}
          />
        )}

      <StyledTableSqare
        paddingLeft={'15px'}
        rowSelection={rowSelection}
        rowKey={record => record?.student_id}
        columns={columns}
        dataSource={isLoading ? [] : candidateDeatils?.result || []}
        pagination={false}
        onChange={onSorting}
        scroll={{
          x: columns?.length * 100 + 150,
        }}
        className={'drivetable-table'}
        bordered
        locale={{
          emptyText: (
            <EmptyWrapper column alignCenter isSpin={isLoading}>
              {!isLoading ? (
                <Flex column alignCenter>
                  <centerText>
                    <EmptyCandidateIcon />
                  </centerText>
                  <centerText>
                    <centerText>No candidates found in this stage</centerText>
                  </centerText>
                  <centerText>
                    Please pick a stage from the funnel above to manage the
                    candidate's applications.
                  </centerText>
                </Flex>
              ) : (
                <Spin />
              )}
            </EmptyWrapper>
          ),
        }}
      />

      <Pagination
        onChange={pagNum => {
          onPageChange(pagNum)
          if (!isAllSelected) {
            handleClearAllClick()
          }
        }}
        totalPages={candidateDeatils?.totalPage * 10}
        pageSize={10}
        current={candidateDeatils?.page + 1}
      />
      <CandidateInfo
        driveData={driveData}
        candidateInfo={candidateInfo}
        setCandidateInfo={setCandidateInfo}
        scheduleDrawer={scheduleDrawer}
        setScheduleDrawer={setScheduleDrawer}
        candidateDetails={candidateDetails}
        rolesMetrics={rolesMetrics}
        candidateInterviewDetails={candidateInterviewDetails}
        candidateInfoData={candidateInfoData}
        updateInterviewStatus={updateInterviewStatus}
        driveId={driveId}
        roleId={roleId}
        getCandidateList={getCandidateList}
        selectedRoundType={selectedRoundType}
        loading={isLoading}
        getRoleMetrics={getRoleMetrics}
        setSelectedCandidate={setSelectedCandidate}
        setSelectedCandidateId={setSelectedCandidateId}
        getSingleCandidateInterviewDetails={getSingleCandidateInterviewDetails}
        setReleaseOffer={setReleaseOffer}
        singleRoleData={singleRoleData}
        stage={stage}
        getNewIndividualDriveStatus={getNewIndividualDriveStatus}
        setIsModalOpen={setIsModalOpen}
        nextRoundFunction={nextRoundFunction}
        setPopSelectedRound={setPopSelectedRound}
        popSelectedRound={popSelectedRound}
        getDriveRoleMetrics={getDriveRoleMetrics}
      />
      <CustomModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
        iconSrc={skipRoundIcon}
        candidatesCount={
          isAllSelected === true
            ? candidateDeatils.notDisabledCount
            : rowSelection.selectedRowKeys.length
        }
        selectedRound={popSelectedRound}
        onRoundChange={setPopSelectedRound}
        rounds={nextRoundData}
        imageWidth={120}
        imageHeight={140}
        width={700}
        modalStyle={{ minWidth: 600, width: '90%' }}
        ButtonWidth="64px"
        ButtonHeight="38px"
        ButtonBorderRadius="10px"
        height={400}
        yesText="Yes"
        noText="NO"
        titleText="Send the {count} candidates into next applicable round"
        subTitleText="Select next applicable round"
      />
      <Drawer
        width="70%"
        title={'Conflicts'}
        placement="right"
        closable={true}
        visible={conflictDrawer}
        content={ConflictContent()}
        footer={false}
        zIndex={1005}
        onClose={() => handleClose()}
      />
      <CustomModal
        isOpen={datePickerModal.visible}
        onClose={() => setDatePickerModal({ visible: false, status: null, selectedDate: null })}
        onConfirm={() => {
          if (datePickerModal.selectedDate) {
            onChangeStatusOffer(datePickerModal.status, datePickerModal.selectedDate)
          }
        }}
        width={380}
        height={'auto'}
        yesText="Confirm"
        noText="Cancel"
        titleText={`Select ${datePickerModal.status === 'JOINED' ? 'Joining' : 'Last working'} Date`}
        customContent={
          <div style={{ 
            padding: '10px', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            justifyContent: 'center'
          }}>
            <DatePicker
              style={{ 
                width: '100%', 
                maxWidth: '220px',
                height: '45px',
                fontSize: '15px',
                borderRadius: '8px',
                border: '1.5px solid #D1D5DB'
              }}
              format="DD/MM/YYYY"
              placeholder={`Select ${datePickerModal.status === 'JOINED' ? 'Joining' : 'Last working'} Date`}
              value={datePickerModal.selectedDate}
              onChange={(date) => {
                setDatePickerModal(prev => ({
                  ...prev,
                  selectedDate: date
                }))
              }}
              // disabledDate={(current) => {
              //   return current && current > moment().endOf('day')
              // }}
            />
          </div>
        }
        ButtonWidth="100px"
        ButtonHeight="40px"
        ButtonBorderRadius="8px"
        disableConfirm={!datePickerModal.selectedDate}
      />
       {stage !== 'all_candidates' && stage !== 'offer' && (
         <SelectAssessmentDrawer
              driveId={driveId}
              roleId={roleId}
              round={stage}
              corporateId={corporateData?.id}
              open={selectAssessmentDrawerOpen}
              onClose={() => setSelectAssessmentDrawerOpen(false)}
              onMappingChange={() => {
                if (typeof getCandidateList === 'function') {
                  const currentFilterPayload = selectedFilterValue || {}
                  getCandidateList(currentFilterPayload, currentPage)
                }
              }}
            />
       )}
    </>
  )
}

export default IndividualDriveTable
